<template>
  <section class="sec-top-intro">
    <div class="box-top-slide">
      <div class="img-top-slide">
        <img src="@/assets/img/column/202602_top.png" />
      </div>
      <div class="img-top-slide_text">
        <h2 class="mb-0 text-right">「老け見え」の原因は骨にあった？<br>整形外科医が警告する顔の骨密度低下とビタミンDの深い関係</h2>
      </div>
    </div>
  </section>

  <section class="column_content">

    <div class="pt-5 mt-5 text-center">
      <p class="mb-3">
      <strong>骨密度の低下は外見にも影響する。<br>
      医師が推奨する「内側からのケア」とは</strong>
      </p>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <p class="mb-3">スキンケアは毎日欠かさないのに、最近鏡を見ると、ふと気になるパーツが多い。</p>
        <p class="mb-3">こめかみがなんとなくすっきりしすぎている気がする、目元のくぼみが深くなった、フェイスラインがぼんやりしてきた…</p>
        <p class="mb-3">そんな変化に心当たりはありませんか？</p>
        <p class="mb-3">実はその「違和感」、肌ではなく<strong>骨の変化</strong>が原因かもしれません。</p>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202602_01.png">
      </div>
    </div>

    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202602_02.png">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <p class="mb-3">日光浴不足や食生活の乱れにより、現代人のビタミンD不足は年々深刻化しています。</p>
        <p class="mb-3"><strong>骨や筋肉の健康を左右するこの栄養素は、外見年齢とも密接につながっている</strong>ことが、専門医への調査で明らかになってきました。</p>
        <p class="mb-3">今回は、整形外科医504人を対象に行った「生活者のビタミンDの認知ギャップ」に関する調査の結果をもとに、知っておきたい骨と美容の深い関係をひもといていきます。</p>
      </div>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">整形外科医の9割超が「骨の危機」を現場で実感している</h3>
        <p class="mb-3">「近年、骨粗しょう症の患者は増えていると感じますか？」という問いに、<strong>約9割の整形外科医（94.1%）が増加を実感</strong>していると回答しました。</p>
        <p class="mb-3">さらに、「診療を通じて患者の骨がもろくなっていると感じる機会はあるか」については、『頻繁にある（38.3%）』『ときどきある（55.2%）』を合わせると、<strong>9割を超える医師が現場で骨の健康状態に危機感を抱いている</strong>ことがわかりました。</p>
        <p class="mb-3">骨粗しょう症は「沈黙の疾患」とも呼ばれ、痛みもなく、気づかないうちに進行するのが厄介なところ。「まだ若いから大丈夫」と思っていても、専門医の目には、その深刻さがはっきりと映っているのです。</p>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202602_03.png">
      </div>
    </div>

    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202602_04.png">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">「老けて見える」のは骨のせい？鏡で確認できる萎縮サイン</h3>
        <p class="mb-3">年齢とともに感じる「なんとなくの老け感」。その正体は、骨密度の低下による<strong>顔の骨格変化</strong>かもしれません。</p>
        <p class="mb-3">医師たちに<strong>「鏡を見て気づける顔の骨の萎縮サイン」</strong>として妥当かどうかを尋ねたところ、以下の項目がいずれも高い割合で支持されました。</p>
        <ul class="mb-3">
          <li><strong>こめかみが凹んで輪郭が変化した</strong><br><small>(約87%)</small></li>
          <li><strong>目元が落ちくぼみ、アイラインが引きにくくなった</strong><br><small>(約83%)</small></li>
          <li><strong>ほうれい線の起点（小鼻横）の溝が深くなった</strong><br><small>(約79%)</small></li>
          <li><strong>フェイスラインがぼやけ、顎周りがもたつく</strong><br><small>(約76%)</small></li>
          <li><strong>唇が薄くなり、口周りのシワが目立つ</strong><br><small>(約81%)</small></li>
        </ul>
      </div>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <p class="mb-3">顔の骨がボリュームを失うと、その上にある筋肉や皮膚が支えを失い、シワやたるみとして表面に出てきます。どんなに高機能なスキンケアを重ねても、土台の骨が変化していれば限界があります。</p>
        <p class="mb-3">「肌ケアはしているのに…」とモヤモヤしている方は、<strong>アプローチの視点をもう一段深める時期</strong>かもしれません。</p>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202602_05.png">
      </div>
    </div>

    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202602_06.png">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">骨と筋肉を守る栄養素、専門医が1位に選んだのは「ビタミンD」</h3>
        <p class="mb-3">では、骨を守るために何を取り入れればいいのでしょうか。</p>
        <p class="mb-3">「骨や筋肉の健康維持において重要な栄養素は何か」という問いに、医師たちが選んだランキングはこちらです。</p>
        <ol class="mb-3">
          <li>1.<strong>ビタミンD（64.8%）</strong></li>
          <li>2.タンパク質（53.1%）</li>
          <li>3.ビタミンK（47.1%）</li>
        </ol>
        <p class="mb-3">「骨といえばカルシウム」というイメージを持っている方も多いはずですが、専門医が最も重視するのはビタミンDでした。</p>
        <p class="mb-3">ビタミンDはカルシウムの吸収を高めるだけでなく、骨の形成や筋肉の維持にも深く関わります。土台をつくる素材（カルシウム）よりも、それを有効に使うための鍵（ビタミンD）を専門医が重視しているという事実は、私たちの常識をアップデートするきっかけになりそうです。</p>
      </div>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">ビタミンDは骨だけじゃない。筋肉の若さにも直結していた</h3>
        <p class="mb-3">「骨のための栄養素」というイメージが強いビタミンDですが、その役割はさらに広がっています。</p>
        <p class="mb-3">ビタミンDが関係すると認識しているものとして、医師が挙げた項目は次の通りです。</p>
        <ol class="mb-3">
          <li><strong>・骨の健康（骨密度・骨代謝など）</strong>72.7%</li>
          <li><strong>・筋肉の機能（筋力・筋機能など）</strong>68.7%</li>
          <li><strong>・関節の動き・身体の可動性</strong>42.0%</li>
        </ol>
        <p class="mb-3">約7割の医師が、ビタミンDを「筋力の維持」にも関与する栄養素として認識しています。</p>
        <p class="mb-3">転倒が怖くなってきた、体が重く感じる、疲れが抜けにくくなった……そんな変化もビタミンD不足のサインである可能性があります。骨だけでなく、体を動かす力そのものを底上げする栄養素として、もっと注目してよさそうです。</p>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202602_07.png">
      </div>
    </div>

    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202602_08.png">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">実は一年中不足しがち。現代人とビタミンDの切っても切れない関係</h3>
        <p class="mb-3">「冬だけ気をつければいい」と思っていませんか？</p>
        <p class="mb-3">「冬季や日光を浴びる時間が少ない生活ではビタミンD不足が起こりやすい」と、<strong>ほぼ全員にあたる96.0%の医師が懸念</strong>しています。</p>
        <p class="mb-3">現代のライフスタイルを振り返ると、室内中心の生活、念入りな紫外線対策、リモートワークの普及など、日光に当たる機会は以前と比べて大幅に減っています。</p>
        <p class="mb-3">美容のために日焼け止めを丁寧に塗ることは正しいケア。でもその一方で、太陽光からのビタミンD生成も同時に抑えているとしたら、別のルートで補う必要があります。季節を問わず、食事やサプリメントによる補給を意識することが、現代の賢いケアのかたちといえるでしょう。</p>
      </div>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">「ビタミンD単体」より「栄養素の掛け算」で、骨ケアの精度を上げる</h3>
        <p class="mb-3">不足したビタミンDをどう補うか。医師の推奨は次の順でした。</p>
        <ol class="mb-3">
          <li>1.食事（72.7%）</li>
          <li>2.飲み物（54.6%）</li>
          <li>3.サプリメント（49.1%）</li>
        </ol>
        <p class="mb-3">食事を基本にしながら、サプリメントで補完するというスタンスが医師の間でも定着してきています。</p>
        <p class="mb-3">さらに一歩踏み込んだ問いも投げかけました。「ビタミンDにビタミンK・亜鉛・マグネシウムを同時摂取することの重要性はどう思うか」という質問に対し、<strong>9割以上の医師が重要と回答</strong>しています。</p>
        <p class="mb-3">栄養素はひとつで機能するわけではありません。<strong>ビタミンDが骨に届くまでには、ビタミンKやマグネシウムが連携して働く</strong>必要があります。まとめて取り入れることで、それぞれが単体で働くよりもずっと効率よく骨・筋肉のケアができる。</p>
        <p class="mb-3">専門医の見解は、サプリメントを選ぶ上でのひとつの答えを示してくれています。</p>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202602_09.png">
      </div>
    </div>

    <div class="layer_01  my-5 py-5">
      <img src="@/assets/img/column/layer-bg_01.jpg">
      <div class="layer-text">
        <h3 class="mb-3">スキンケアの次は、骨ケアを習慣に</h3>
        <p class="mb-3">日焼け止めを丁寧に塗り、帽子をかぶり、日陰を選んで歩く。<br>肌を守るための習慣として、それは間違いなく正解です。</p>
        <p class="mb-3">でも、同時にこんな事実もあります。<br>紫外線を遮るほど、体内でのビタミンD生成は抑えられていく。</p>
        <p class="mb-3">美肌のための紫外線対策が、骨の健康を静かに損なっているかもしれない。</p>
        <p class="mb-3">そのジレンマは、現代の美容習慣が抱える見えにくいリスクのひとつです。<br>太陽の恩恵を受けにくくなった分だけ、<br>食事やサプリメントで意識的に補う視点が、<br>これからのケアには欠かせません。</p>
        <p class="mb-3">肌を守りながら、骨も守る。</p>
        <p class="mb-3">その両立が、年齢を重ねても自分らしくいるための、<br>新しい美容の常識になっていくのかもしれません。</p>
      </div>
    </div>
    
  </section>


  <!-- トップに戻るボタン -->
  <button id="page-top" class="btn" v-on:click="scrollTop">
    TOP
  </button>

</template>

<style scoped>
.column_content h2,.column_content h3 {
  font-weight: 500 !important;
}
small {
  font-size: .7em;
}
ul {
  list-style: disc;
  margin-left: 25px;
}

.feature-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 50px;
}
.feature-row_item_image img {
  width: 100%;
}
.feature-row_item_text h3 {
  font-size: 1.25em;
}

button#page-top {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 100;
}


.layer_01 {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url('../../assets/img/column/layer-bg_01.jpg');
  background-size: cover;
  background-position: center;
  min-height: 500px; /* 最小高さを設定しておくと、極端に小さくなるのを防げます */
  padding: 20px; /* テキストと画像の端の間に余白を設定 */
}
.layer_01 img {
  display: none; /* 画像は背景として使用するので非表示にします */
}
.layer_01 .layer-text {
  /* padding: 10px; */
  text-align: center;
  max-width: 90%; /* 文字が画像からはみ出さないように最大幅を設定 */
  word-wrap: break-word; /* 長い単語が折り返されるようにする */
  color: #424242;
  font-weight: 500;
}
.layer_01 .layer-text .fs-2 {
  font-size: 2em;
}

.feature-row_product_list {
  align-items: inherit;
  justify-content: flex-start;
}
.feature-row_column_list {
  align-items: inherit;
  justify-content: center;
}
.feature-row_product_item {
  width: 25%;
  padding: 5px;
  text-align: center;
}
.feature-row_column_item {
  width: 33%;
  padding: 5px;
  text-align: center;
}
.feature-row_product_detail {
  color: #333;
}
.feature-row_product_cate {
  font-size: .8em;
  color: #6b6b67;
  opacity: .65;
}
.feature-row_voice_list {
  align-items: baseline;
}
.feature-row_voice_list path.a {
  fill: none;
  stroke: #000;
  stroke-width: 2px;
}
.feature-row_voice_list .icon svg {
  width: 70px;
}
.feature-row_voice_list .feature-row_voice_item {
  width: 33%;
  padding: 5px;
  text-align: center;
}

.box-top-slide {
  position: relative;
}
.img-top-slide img {
  width: 100%;
  height: 422px;
  object-fit: cover;
  object-position: left;
}
.img-top-slide_text {
  position: absolute;
  bottom: 30px;
  right: 30px;
  color: #fff;
}
.img-top-slide_text h2 {
  font-size: 2em;
  font-weight: 500 !important;
}
.img-top-slide_text h2 span {
  font-size: .6em;
}

.layer_02 .layer-text,.layer_03 .layer-text,.layer_04 .layer-text {
  background-color: #cacaca;
  padding: 10px;
}
.layer_02 .layer-text .layer-text-inner,.layer_03 .layer-text .layer-text-inner,.layer_04 .layer-text .layer-text-inner {
  background-color: #fff;
  padding: 15px;
}
.layer_02 .layer-text .layer-text-inner h2 span,.layer_03 .layer-text .layer-text-inner h2 span,.layer_04 .layer-text .layer-text-inner h2 span {
  font-size: .6em;
}
@media screen and (min-width: 991px) {
    .layer_02 {
      position: relative;
      display: flex;
      align-items: flex-start;
      background-image: url('../../assets/img/column/202501_05.jpg');
      background-size: cover;
      min-height: 600px;
      padding: 60px;
    }
    .layer_03 {
      position: relative;
      display: flex;
      align-items: flex-start;
      background-image: url('../../assets/img/column/202501_06.jpg');
      background-size: cover;
      min-height: 600px;
      padding: 60px;
    }
    .layer_04 {
      position: relative;
      display: flex;
      align-items: flex-start;
      background-image: url('../../assets/img/column/202501_07.jpg');
      background-size: cover;
      min-height: 600px;
      padding: 60px;
    }
    .layer_02 img,.layer_03 img,.layer_04 img {
      display: none; /* 画像は背景として使用するので非表示にします */
    }
    .layer_02 .layer-text,.layer_03 .layer-text,.layer_04 .layer-text {
      padding: 15px;
      max-width: 45%; /* 文字が画像からはみ出さないように最大幅を設定 */
      word-wrap: break-word; /* 長い単語が折り返されるようにする */
      color: #424242;
      background-color: #fff;
    }
}
@media screen and (max-width: 699px) {
    .img-top-slide_text h2 {
      font-size: inherit;
    }
    .img-top-slide_text h2 span {
      font-size: .8em;
    }
    .img-top-slide_text {
      left: 10px;
    }
}
@media screen and (min-width: 769px) {
   .feature-row_item_text_right {
    padding-left: 60px;
   }
   .feature-row_item_text_left {
    padding-right: 60px;
   }
   .w-40 {
    width: 40%;
   }
   .w-60 {
    width: 60%;
   }
   .feature-row.step .step-item {
    width: 33.33%;
   }
   .img-top-slide img {
    height: 650px;
   }
}
@media screen and (min-width: 1px) and (max-width: 768px) {
  .column_content h2 {
    margin-bottom: 40px;
  }
  .feature-row {
    flex-direction: column;
  }
  .feature-row_item_image {
    order: 1;
    margin-bottom: 15px;
  }
  .feature-row_item_text {
    order: 2;
  }
  .feature-row_voice_item, .feature-row_product_item, .feature-row_column_item {
      width: 100% !important;
  }
  .w-50, .w-25, .w-75 {
    width: 100% !important;
  }
  .layer-text {
    font-size: .8em;
  }
  .layer_01 .layer-text .fs-2 {
    font-size: 1.5em;
  }
}
</style>

<script>
import $ from "jquery";

$(function() {
 var topBtn = $('#page-top');    
 topBtn.hide();
 //スクロールが500に達したらボタン表示
 $(window).scroll(function () {
 if ($(this).scrollTop() > 500) {
 topBtn.fadeIn();
        } else {
 topBtn.fadeOut();
        }
    });
    
});

// ページ内リンク
export default{
  data: () => {
    return {isActive: []}
  },
  mounted (){
    window.scroll(0, 0);
    for(let i = 0; i < 2; i++) {
      this.isActive[i] = false
    }
  },
  methods: {
    scrollToAnchorPoint(refName) {
      const el = this.$refs[refName]
      el.scrollIntoView({ behavior: 'smooth'})
    },
    openInfo(ref) {
      console.log(ref)
      this.isActive[ref] = true
      console.log(this.isActive[ref])
    },
    closeInfo(ref) {
      console.log(ref)
      this.isActive[ref] = false
      console.log(this.isActive[ref])
    },
    scrollTop(){
      window.scrollTo({
      top: 0,
      behavior: "smooth"
      })
    }
  }
}

</script>